import { Booking } from './booking.model';

export class BookingBundle {
  bookings: Booking[];
  cost: number;

  constructor(bookings?: Booking[], cost?: number) {
    this.bookings = bookings || [];
    this.cost = cost || 0;
  }
}
